<template>
  <svg
    class="polygon-1"
    width="64"
    height="65"
    viewBox="0 0 64 65"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M28.5359 6.59765C30.0755 3.93099 33.9245 3.93099 35.4641 6.59766L56.2487 42.5977C57.7883 45.2643 55.8638 48.5977 52.7846 48.5977H11.2154C8.13619 48.5977 6.21169 45.2643 7.75129 42.5977L28.5359 6.59765Z"
      fill="#FFAD0F"
    />
  </svg>
</template>
